export const CSV_URL = './csv/16bit_octo_ontology.csv';
export const DEFAULT_STATE_URL = './json/landing_v4.json';
export const TARGET_LAYER_NAME = 'Segmentation Labels';
export const NEUROGLANCER_SCRIPT_URLS = [
  './822.f53317e7d19e4212.js',
  './213.e4e7d7e2081b694d.js',
  './205.6aca511f175e6a71.js',
  './51.34ccb8152bac0c2a.js',
  './main.e5a9481658d9aca6.js'
];
